module.exports = __webpack_public_path__ + "static/img/3.671228e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc/3.png
// module id = Vob8
// module chunks = 0